export default {
  header: 'Nieuwe bestellingen gepauzeerd',
  text: 'Tik ergens om te herstellen',
};
